<template>
  <div>
    <div class="row" v-if="showFilters">
      <div class="col-12 col-md-4">
        <label class="form-label">{{$t('licenses.license_entity')}}:</label>
        <multiselect
          v-model="filters.entity"
          :options="entitiesRead"
          track-by="id"
          label="name"
          select-label=""
          selected-label=""
          deselect-label=""
          placeholder="---"
          :allow-empty="true"
          :multiple="false"
          :searchable="true"
          >

          <template slot="clear" slot-scope="props">
            <div class="multiselect__clear" v-if="filters.entity" @mousedown.prevent.stop="filters.entity = null"></div>
          </template>
        </multiselect>
      </div>
      <div class="col-12 col-md-4">
        <label class="form-label">{{$t('licenses.license_state')}}:</label>
        <multiselect
          v-model="filters.licenseState"
          :options="licenseStateOptions"
          track-by="id"
          label="name"
          select-label=""
          selected-label=""
          deselect-label=""
          placeholder="---"
          :allow-empty="true"
          :multiple="false"
          :searchable="true"
          >

          <template slot="singleLabel" slot-scope="{ option }">
            <span>{{ $t(option.name) }}</span>
          </template>
          <template slot="option" slot-scope="{option}">
            <span>{{ $t(option.name) }}</span>
          </template>

          <template slot="clear">
            <div class="multiselect__clear" v-if="filters.licenseState" @mousedown.prevent.stop="filters.licenseState = null"></div>
          </template>
        </multiselect>
      </div>
    </div>

    <v-server-table
      :columns="columns"
      :options="tableOptions"
      @row-click="click => redirectToKiosk(click.row.id)"
      id="kioskLicensesTable"
      ref="kioskLicensesTable"
      name="kioskLicensesTable"
      @filter="filterListener"
    >
      <span slot="afterFilter" v-if="showResetIcon">
        <i class="fa fa-times reset-filter" @click="resetFilter"></i>
      </span>

      <span slot="kiosk_type" slot-scope="props">
        {{props.row.kiosk_type ? $t(kioskTypesAdapter[props.row.kiosk_type]) : 'N/A'}}
      </span>

      <span slot="serial" slot-scope="props">
          {{props.row.device_serial ? props.row.device_serial : props.row.serial}}
        </span>

      <span slot="license" slot-scope="props">
        <span v-if="props.row.active_license" @click.prevent.stop="redirectToLicense(props.row.active_license)">
          <a href="#"> {{props.row.active_license.name}} </a>
          <span v-if="props.row.active_license.canceled_at!==null"> ({{$t('licenses.states.canceled')}}) </span>
        </span>
        <span v-else>
          N/A
        </span>
      </span>

      <span slot="created_at" slot-scope="{row}">
        {{row.created_at | localTime('YYYY-MM-DD HH:mm', '---')}}
      </span>

      <span slot="license_type" slot-scope="props">
        {{props.row.active_license ? $t(licenseTypesAdapter[props.row.active_license.license_type_id]) : 'N/A'}}
      </span>

      <span slot="owner" slot-scope="props">
        {{props.row.active_license && props.row.active_license.entity ? props.row.active_license.entity.name : 'N/A'}}
      </span>

      <span slot="licensed_until" slot-scope="props">
        {{props.row.active_license ? props.row.active_license.end_date : 'N/A'}}
      </span>

      <span slot="checkin_at" slot-scope="{row}">
        {{row.checkin_at | localTime('YYYY-MM-DD HH:mm', '---')}}
      </span>

      <span slot="type" slot-scope="props">
        {{props.row.type ? props.row.type.name : 'N/A'}}
      </span>

      <span slot="sessions" slot-scope="props">
        {{props.row.sessions ? props.row.sessions.length : 0 }}
      </span>

      <span slot="promoter" slot-scope="props" style="min-width: 300px;">
        {{props.row.last_session && props.row.last_session.promoter ? props.row.last_session.promoter.name : 'N/A'}}
      </span>

      <span slot="promoter_entity" slot-scope="props" style="min-width: 300px;">
        {{props.row.last_session && props.row.last_session.promoter && props.row.last_session.entity ? props.row.last_session.promoter.entity.name : 'N/A'}}
      </span>

  </v-server-table>
  </div>
</template>
<script>
import Multiselect from 'vue-multiselect'
import LocalStorageHelper from '@/local-storage/LocalStorageHelper'
import { TABLE_LICENSE_KIOSKS } from '@/local-storage/LocalStorageKeys'
import TableQueryMixin from '@/mixins/TableQueryMixin'

export default {
  props: {
    showFilters: {
      type: Boolean,
      required: false,
      default: false
    },
    querySearch: {
      type: String,
      required: false,
      default: null
    },
    customQueries: {
      type: Object,
      required: true,
      default: null
    }
  },
  components: {
    Multiselect
  },
  mixins: [
    TableQueryMixin
  ],
  mounted: function () {
    //this.loadLocalStorage()
    this.loadDataCustomQueries()
  },
  data () {
    return {
      showResetIcon: false,
      showExtraFilters: false,
      filters: {
        entity: null,
        licenseState: null
      },
      licenseTypesAdapter: {
        1: 'licenses.types.standard',
        2: 'licenses.types.premium'
      },
      kioskTypesAdapter: {
        1: 'kiosks.regular_kiosk',
        2: 'kiosks.portable_kiosk'
      },
      licenseStateOptions: [
        {
          id: 1,
          name: 'licenses.states.valid_license'
        },
        {
          id: 2,
          name: 'licenses.states.expired_license'
        },
        {
          id: 3,
          name: 'licenses.states.canceled'
        },
        {
          id: 4,
          name: 'licenses.states.no_license'
        }
      ],
      columns: [
        'created_at',
        'name',
        'serial',
        'kiosk_type',
        'license',
        'license_type',
        'owner',
        'licensed_until',
        'checkin_at',
        'promoter',
        'promoter_entity'
      ],
      queryUrl: this.$store.state.evollead_server + '/kiosks',
      tableOptions: {
        filterable: true,
        sortable: ['name', 'licensed_until', 'kiosk_type', 'created_at'],
        headings: {
          name: this.$t('users.inputs.name'),
          serial: 'Serial',
          version: this.$t('kiosks.version'),
          licensed_until: this.$t('kiosks.licensed_until'),
          created_at: this.$t('kiosks.created_at'),
          owner: this.$t('kiosks.owner'),
          promoter: this.$t('kiosks.promoter'),
          sessions: this.$t('kiosks.nr_sessions'),
          checkin_at: this.$t('kiosks.checkin_at'),
          kiosk_type: this.$t('kiosks.type'),
          promoter_entity: this.$t('kiosks.promoter_entity'),
          license: this.$t('licenses.license'),
          license_type: this.$t('licenses.license_type'),
        },
        customFilters: ['entity', 'with', 'licenseState'],
        initFilters: {
          with: 'lastPromoter,type,leads'
        }
      },
    }
  },
  computed: {
    numberOfFilters: function () {
      let count = 0
      if (this.filters.entity) count++
      if (this.filters.licenseState) count++
      return count
    },
    leadsService: function () {
      return this.$store.state.services.find(s => s.url === this.$store.state.evollead_server)
    },
    entitiesWrite: function () {
      return this.leadsService.entities.filter(entity => {
        return this.leadsService.user_permissions.some(p => p.info_type === 110 && p.access_type >= 2 && (p.entity_id === null || p.entity_id === entity.id))
      })
    },
    entitiesRead: function () {
      return this.leadsService.entities.filter(entity => {
        return this.leadsService.user_permissions.some(p => p.info_type === 110 && p.access_type >= 1 && (p.entity_id === null || p.entity_id === entity.id))
      })
    }
  },
  methods: {
    getTableReference: function () {
      return this.$refs.kioskLicensesTable
    },
    redirectToKiosk: function (kioskId) {
      this.$router.push({ name: `${this.leadsService.slug}licenses/kiosks/id`, params: { id: kioskId } })
    },
    filterListener (query) {
      this.showResetIcon = query.length > 0
    },
    resetFilter () {
      this.showResetIcon = false
      this.getTableReference().setFilter('')
    },
    selectDefaultEntity: function () {
      if (this.entitiesWrite.length > 0) {
        let ownEntity = this.entitiesWrite.find(e => e.id === this.$auth.user().entity.id)
        if (ownEntity) {
          this.filters.entity = ownEntity
        } else {
          this.filters.entity = this.entitiesWrite[0]
        }
      }
    },
    refreshTable: function () {
      this.getTableReference().refresh()
    },
    /*loadLocalStorage: function () {
      let state = LocalStorageHelper.get(TABLE_LICENSE_KIOSKS)
      console.log(state.query);

      if (state) {
        if (state.customQueries.entity) {
          this.filters.entity = this.entitiesWrite.find(entity => state.customQueries.entity === entity.id)
        }

        if (state.customQueries.licenseState) {
          this.filters.licenseState = this.licenseStateOptions.find(licenseState => state.customQueries.licenseState === licenseState.id)
        }
      }
    },*/
    loadDataCustomQueries: function() {
      if (this.customQueries.entity) {
        this.filters.entity = this.entitiesWrite.find(entity => state.customQueries.entity === entity.id)
      }

      if (this.customQueries.licenseState) {
        this.filters.licenseState = this.licenseStateOptions.find(licenseState => state.customQueries.licenseState === licenseState.id)
      }
    },
    redirectToLicense: function (license) {
      this.$router.push({ name: `${this.leadsService.slug}licenses/id`, params: { id: license.id } })
    }
  },
  watch: {
    numberOfFilters: function (nrFilters) {
      this.$emit('filters-updated', nrFilters)
    },
    querySearch: function (value) {
      this.getTableReference().setFilter(value)
    },
    'filters.entity': function (newValue) {
      this.emitTableFilter('vue-tables.kioskLicensesTable.filter::entity', newValue ? newValue.id : null)
    },
    'filters.licenseState': function (newValue) {
      this.emitTableFilter('vue-tables.kioskLicensesTable.filter::licenseState', newValue ? newValue.id : null)
    }
  }
}
</script>

<style lang="scss">
#kioskLicensesTable {
  tr {
    cursor: pointer;
    &:hover {
      a {
        color: white;
        text-decoration: underline;
      }
    }
  }
}
</style>
